module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "DataTable"
    }
  }, [_c('table', {
    class: _vm.stylingClass,
    attrs: {
      "cellspacing": "0",
      "width": "100%",
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.dtHeaders), function(header, i) {
    return _c('th', {
      attrs: {
        "data-class": (i == 0) ? 'expand' : null
      }
    }, [_vm._v(" " + _vm._s(header))])
  }), 0)]), _vm._v(" "), _c('tbody')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b7ddff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/vue/datatable.vue
// module id = 946
// module chunks = 0